var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { Component, InjectReactive, Vue } from 'vue-property-decorator';
import { CallLogOutcomes } from 'packages/call_logs/CallLog';
import { Candidate } from '@/packages/v3/jobs/Candidate';
import { Job } from 'packages/v3/jobs/Job';
import { namespace } from 'vuex-class';
var callLogsModule = namespace('callLogs');
var talentCardModule = namespace('talentCard');
var jobsModule = namespace('jobs');
var TimelineView = /** @class */ (function (_super) {
    __extends(TimelineView, _super);
    function TimelineView() {
        var _a;
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.callLogsOutcomeShortLabels = (_a = {},
            _a[CallLogOutcomes.BUSY] = _this.$t('call_logs.outcomes_short.busy'),
            _a[CallLogOutcomes.QUALIFIED] = _this.$t('call_logs.outcomes_short.qualified'),
            _a[CallLogOutcomes.UNQUALIFIED] = _this.$t('call_logs.outcomes_short.unqualified'),
            _a[CallLogOutcomes.UNREACHABLE] = _this.$t('call_logs.outcomes_short.unreachable'),
            _a);
        return _this;
    }
    Object.defineProperty(TimelineView.prototype, "groupedCallLogs", {
        get: function () {
            // sort call logs to start from the oldest ones for unreachable call logs grouping;
            // this is needed for a less expensive grouping algorithm as we want to have only latest
            // unreachable call log of grouped ones
            var ascCallLogs = __spreadArray([], this.callLogs).sort(function (a, b) { return a.createdAt.unix() - b.createdAt.unix(); });
            var groupedCallLogs = [];
            var count = 1;
            for (var i = 0; i < ascCallLogs.length; i++) {
                var callLog = ascCallLogs[i];
                var nextCallLog = ascCallLogs[i + 1];
                // if the current and next call logs are unreachable, group them by skipping current
                // call log and increasing the count
                if (this.isUnreachable(callLog) && this.isUnreachable(nextCallLog)) {
                    count++;
                }
                else {
                    groupedCallLogs.push({ callLog: callLog, count: count });
                    count = 1;
                }
            }
            return groupedCallLogs.reverse();
        },
        enumerable: false,
        configurable: true
    });
    TimelineView.prototype.isUnreachable = function (callLog) {
        return (callLog === null || callLog === void 0 ? void 0 : callLog.outcome) === CallLogOutcomes.UNREACHABLE;
    };
    TimelineView.prototype.callLogStageName = function (callLog) {
        var _a, _b;
        var toStage = (_b = (_a = this.job) === null || _a === void 0 ? void 0 : _a.stages) === null || _b === void 0 ? void 0 : _b.find(function (stage) { var _a; return stage.id === ((_a = callLog.pipelineStageId) === null || _a === void 0 ? void 0 : _a.toString()); });
        return toStage.name;
    };
    TimelineView.prototype.logCall = function () {
        if (typeof window.hj === 'function') {
            window.hj('event', 'log-call.start');
        }
    };
    var _a, _b;
    __decorate([
        InjectReactive(),
        __metadata("design:type", String)
    ], TimelineView.prototype, "routeNamePrefix", void 0);
    __decorate([
        callLogsModule.State,
        __metadata("design:type", Array)
    ], TimelineView.prototype, "callLogs", void 0);
    __decorate([
        jobsModule.State,
        __metadata("design:type", typeof (_a = typeof Job !== "undefined" && Job) === "function" ? _a : Object)
    ], TimelineView.prototype, "job", void 0);
    __decorate([
        talentCardModule.State,
        __metadata("design:type", typeof (_b = typeof Candidate !== "undefined" && Candidate) === "function" ? _b : Object)
    ], TimelineView.prototype, "candidate", void 0);
    TimelineView = __decorate([
        Component
    ], TimelineView);
    return TimelineView;
}(Vue));
export default TimelineView;
